import { render, staticRenderFns } from "./MealsEmissionFactors.vue?vue&type=template&id=023818cd&scoped=true"
import script from "./MealsEmissionFactors.vue?vue&type=script&lang=js"
export * from "./MealsEmissionFactors.vue?vue&type=script&lang=js"
import style0 from "./MealsEmissionFactors.vue?vue&type=style&index=0&id=023818cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023818cd",
  null
  
)

export default component.exports